"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBackHandler = void 0;
var useBackHandler_1 = require("./useBackHandler");
Object.defineProperty(exports, "useBackHandler", { enumerable: true, get: function () { return useBackHandler_1.useBackHandler; } });
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvaG9va3MvbWl4ZWQvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLDREQUE0RDs7O0FBRTVELG1EQUFrRDtBQUF6QyxnSEFBQSxjQUFjLE9BQUEifQ==